// src/components/Navbar.js
import React from 'react';
import { AppBar, Toolbar, IconButton, Typography, Menu, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleMenu = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <AppBar position="static">
      <Toolbar>
        {/* Make "Nada Upashama" a clickable link */}
        <Typography
          component={Link}
          to="/"
          variant="h6"
          sx={{ flexGrow: 1, textDecoration: 'none', color: 'inherit' }}
        >
          Nada Upashama
        </Typography>
        
        <IconButton edge="end" color="inherit" onClick={handleMenu}>
          <MenuIcon />
        </IconButton>
        
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem component={Link} to="/about" onClick={handleClose}>About</MenuItem>
          <MenuItem component={Link} to="/loudness" onClick={handleClose}>Pitch & Loudness</MenuItem>
          <MenuItem component={Link} to="/mcl" onClick={handleClose}>MCL</MenuItem>
          <MenuItem component={Link} to="/fdt" onClick={handleClose}>FDT</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
